// extracted by css-extract-rspack-plugin
export default {"blankslate":"CommentsEmptyState-module__blankslate__gEbbC"};